export enum CommunicationChannelFilter {
  All = 'All',
  Calls = 'Calls',
  SMS = 'SMS',
  Email = 'Email',
  Fax = 'Fax',
}

export enum CommunicationItemType {
  Calls = 'Calls',
  SMS = 'SMS',
  Email = 'Email',
  Fax = 'Fax',
}

export enum CommunicationDirection {
  Inbound = 'Inbound',
  Outbound = 'Outbound',
}

export enum CommunicationStatus {
  Received = 'Received',
  Sent = 'Sent',
  Read = 'Read',
  Delivered = 'Delivered',
  Connected = 'Connected',
  Missed = 'Missed',
}

export interface ICommunicationHistory {
  id: string
  type: CommunicationItemType
  direction: CommunicationDirection
  patientName: string
  text: string
  timestamp: string
  status: CommunicationStatus
  conversationId?: string // For SMS
  messageCenterRef?: string
}
